import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import {Link} from 'react-router-dom';

import BEM from "./Task.module.scss";

export const Task = ({
  type = "regular",
  isCompleted = false,
  title = "Task name",
  link,
  highlighting = "#eeff3e",
  children,
  className = "",
  onCompleteClick,
}) => {

  const BodyTag = link ? Link : 'div';

  return (
    <li className={BEM.block + " " + className}>
      <button className={BEM.completeBtn} onClick={onCompleteClick}>
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {isCompleted && (
            <>
              <circle cx="5.5" cy="5.5" r="3.5" fill={highlighting} />
              <circle cx="5.5" cy="5.5" r="3.5" stroke={highlighting} />
            </>
          )}
          <circle cx="5.5" cy="5.5" r="5" stroke={highlighting} />
        </svg>
      </button>

      <BodyTag
        className={cn({
          [BEM.title]: true,
          [BEM.title___completed]: isCompleted,
          [BEM.title___link]: BodyTag === 'a',
        })}
        to={link}
      >
        {title}
      </BodyTag>

      <p className={BEM.childrenContainer}>{children}</p>
    </li>
  );
};

Task.propTypes = {
  type: PropTypes.oneOf(["regular", "fixed"]),
  isCompleted: PropTypes.bool,
  title: PropTypes.node.isRequired,
  highlighting: PropTypes.string, // color
  className: PropTypes.string,
  onCompleteClick: PropTypes.func,
};
